module.exports = __webpack_public_path__ + "media/images/pages/contributor_overview/img-19-391a35b3ae6c15472d814746f6d55cb6.png";